import { ScriptEditor } from "@src/frontend/components/ScriptEditor";
import { REQUIRED_RULES } from "@src/frontend/utils";
import type { UserScriptAction } from "@src/frontend/utils/types";
import type { ScriptActionPayload } from "@src/utils/agent";
import { Divider, Flex, Form, Input, InputNumber, Radio, Typography } from "antd";
import FormItem from "antd/es/form/FormItem";

interface Props {
  name: any[];
  action?: UserScriptAction;
  step: number;
}

const RULES = [REQUIRED_RULES];

export const PayloadEditor = (props: Props) => {
  const { action } = props.action || {};
  if (!action) return <Divider>请选择动作</Divider>;
  switch (action) {
    case "CLICK": {
      return (
        <Form.Item label='CSS 选择器' name={[...props.name, 'selector']} rules={RULES}>
          <Input placeholder="likes: #id > .class > tag" />
        </Form.Item>
      );
    }
    case "INPUT": {
      const { type } = (props.action?.payload || {}) as ScriptActionPayload<'INPUT'>;
      const valueLabel = type ? type === 'raw' ? '值' : '资源键名' : '';
      return (
        <>
          <Form.Item label='CSS 选择器' name={[...props.name, 'selector']} rules={RULES}>
            <Input placeholder="likes: #id > .class > tag" />
          </Form.Item>
          <Form.Item
            label='类型'
            name={[...props.name, 'type']}
            rules={RULES}
            tooltip={
            <Flex vertical gap={4}>
              <Typography.Text>值：需要输入的具体值</Typography.Text>
              <Typography.Text>资源：从后续配置的资源中获取</Typography.Text>
            </Flex>}
          >
            <Radio.Group
              block
              optionType="button"
              options={[{ label: '值', value: 'raw' }, { label: '资源', value: 'res_key' }]}
            />
          </Form.Item>
          <Form.Item rules={RULES} label={valueLabel} name={[...props.name, 'value']} tooltip={type === 'res_key' ? '将使用此值查找资源对应键的值' : ''}>
            <Input placeholder={type === 'res_key' ? '将使用此值查找资源对应键的值' : '将要输入的值'} />
          </Form.Item>
        </>
      );
    }
    case "GOTO": {
      const { type } = (props.action?.payload || {}) as ScriptActionPayload<'GOTO'>;
      const valueLabel = type ? type === 'raw' ? 'URL' : '资源键名' : '';
      return (
        <>
          <Form.Item
            label='类型'
            name={[...props.name, 'type']}
            rules={RULES}
            tooltip={
            <Flex vertical gap={4}>
              <Typography.Text>值：需要输入的具体值</Typography.Text>
              <Typography.Text>资源：从后续配置的资源中获取</Typography.Text>
            </Flex>}
          >
            <Radio.Group
              block
              optionType="button"
              options={[{ label: '值', value: 'raw' }, { label: '资源', value: 'res_key' }]}
            />
          </Form.Item>
          <Form.Item rules={RULES} label={valueLabel} name={[...props.name, 'value']}>
            <Input placeholder={type === 'res_key' ? '将使用此值查找资源对应键的值' : '将要输入的值'} />
          </Form.Item>
        </>
      );
    }
    case "SLEEP": {
      return (
        <Form.Item rules={RULES} label='等待时间(ms)' name={[...props.name, 'timeoutms']}>
          <InputNumber style={{ width: '100%' }} placeholder="1 秒 = 1000ms" min={0} step={500} />
        </Form.Item>
      );
    }
    case "RUN_JS": {
      const { remark } = props.action?.payload || {} as any
      return (
        <>
          <Form.Item label='JS 脚本代码' rules={RULES} name={[...props.name, 'code']}>
            <ScriptEditor title={remark} height={'100%'} />
          </Form.Item>
          <FormItem label='备注' name={[...props.name, 'remark']}>
            <Input />
          </FormItem>
        </>
      );
    }
    case "WAIT_ELEMENT": {
      return (
        <>
          <Form.Item label='CSS 选择器' name={[...props.name, 'selector']} rules={RULES}>
            <Input placeholder="likes: #id > .class > tag" />
          </Form.Item>
          <Form.Item label='等待时间(ms)' name={[...props.name, 'timeoutms']}>
            <InputNumber style={{ width: '100%' }} min={0} step={500} />
          </Form.Item>
          <Form.Item label='重试次数' name={[...props.name, 'retry']}>
            <InputNumber style={{ width: '100%' }} min={0} step={1} />
          </Form.Item>
        </>
      );
    }
    default:
      return <Divider>未知类型</Divider>;
  }
}